// extracted by mini-css-extract-plugin
module.exports = {"containerBackground":"_1Y0hN"};